"use strict";
var pager_component_1 = require('./pagination/pager.component');
exports.PagerComponent = pager_component_1.PagerComponent;
var pagination_component_1 = require('./pagination/pagination.component');
exports.PaginationComponent = pagination_component_1.PaginationComponent;
var pagination_module_1 = require('./pagination/pagination.module');
exports.PaginationModule = pagination_module_1.PaginationModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/components/pagination.js
// module id = 1198
// module chunks = 0